export const getToken = () => {
  // Retrieves the token stored under the key 'zTaskAuthToken' from local storage.
  const token = localStorage.getItem("zTaskAuthToken");
  if (!token) {
    console.warn("Authentication token 'zTaskAuthToken' not found in local storage.");
    return null;
  }
  return token;
};